export interface ActorNodeChildrenMap {}

export const ACTORS_IN_PROD = false;

import {PolyEngine} from '../../../Poly';
export class ActorRegister {
	static run(poly: PolyEngine) {}
}
